import { updateUrlFiltersParam, updateUrlParam } from '../../util/url'

export const removeFilter = (state, filter) => {
  const index = state.filters.findIndex(el => el === filter)
  if (index === -1) return
  state.filters.splice(index, 1)
  updateUrlFiltersParam(state.filters)
}

export const addOrUpdateFilterByType = (state, { filter }) => {

  const index = state.filters.findIndex(f => f.type === filter.type)
  if (index === -1) {
    state.filters.push(filter)
  } else {
    state.filters[index] = Object.assign(state.filters[index], filter)
  }
  updateUrlFiltersParam(state.filters)
}

export const testUpdateFilter = (state, filter) => {
  state.filters = [...filter]
  updateUrlFiltersParam(state.filters)
}

export const clearFilters = (state) => {
  state.filters = []
  state.search = ''
  updateUrlFiltersParam(state.filters)
  updateUrlParam('search', state.search)
}

export const setColours = (state, data) => {
  state.colours = data
}

export const setLoaded = (state, data) => {
  state.loaded = data
}

export const setSearch = (state, data) => {
  state.search = data
  updateUrlParam('search', state.search)
}

export const setFilters = (state, data) => {
  state.filters = data
  updateUrlFiltersParam(state.filters)
}
